import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { checkIsClientSide } from "../../../../../utils/ym";
import { Content } from "../../../../dependencies/getContent/Content";
import { UserAccountInfo } from "../../../../dependencies/getUserAccountInfo/UserAccountInfo";
import { findFirst } from "../../../../../utils/arrays";
export var login = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var _findFirst, _Content$getInstance$, profileUrl, loginUrl, _UserAccountInfo$getI, accountNumber, url;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (checkIsClientSide()) {
            _Content$getInstance$ = Content.getInstance().getData(), profileUrl = _Content$getInstance$.profileUrl, loginUrl = _Content$getInstance$.loginUrl;
            _UserAccountInfo$getI = UserAccountInfo.getInstance().getData(), accountNumber = _UserAccountInfo$getI.accountNumber;
            url = (_findFirst = findFirst([accountNumber && profileUrl])) !== null && _findFirst !== void 0 ? _findFirst : loginUrl;
            window.location.href = url;
          }
        case 1:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function login() {
    return _ref.apply(this, arguments);
  };
}();